import { configData } from "../config";

// Pictures uploaded on the live site after its files were copied here are missing from this
// site's files (/basic/web/files, /basic/web/pictures/<style>) and from the Drupal copy. The live
// site keeps the same files under /sites/default/files, so a picture that fails to load is
// tried there once before the placeholder is shown.

const LIVE_FILES = configData.DRUPAL_LIVE_DOMAIN_URL + '/sites/default/files/';

// The live site's address of one of this site's (or the Drupal copy's) files, or '' for any other picture
export const liveFileUrl = (src) => {
    let url;
    try {
        url = new URL(src, window.location.href);
    } catch (e) {
        return '';
    }
    const path = url.pathname;
    if (url.origin === window.location.origin) {
        if (path.startsWith('/basic/web/files/')) {
            return LIVE_FILES + path.slice('/basic/web/files/'.length);
        }
        // User pictures in one of Drupal's image styles: /basic/web/pictures/<style>/<file>
        const styled = path.match(/^\/basic\/web\/pictures\/([^/]+)\/([^/]+)$/);
        if (styled) {
            return LIVE_FILES + 'styles/' + styled[1] + '/public/pictures/' + styled[2];
        }
        if (path.startsWith('/basic/web/pictures/')) {
            return LIVE_FILES + 'pictures/' + path.slice('/basic/web/pictures/'.length);
        }
        return '';
    }
    if (url.origin === new URL(configData.DRUPAL_DOMAIN_URL).origin && path.startsWith('/sites/')) {
        return configData.DRUPAL_LIVE_DOMAIN_URL + path;
    }
    return '';
};

// An img onError handler: the live site's copy of the picture first, then the placeholder
export const liveCopyOrPlaceholder = (placeholder) => (event) => {
    const img = event.currentTarget;
    const live = img.dataset.liveTried ? '' : liveFileUrl(img.src);
    if (live) {
        img.dataset.liveTried = '1';
        img.src = live;
    } else if (img.src !== placeholder) {
        img.src = placeholder;
    }
};
